const TEXTS: Record<'listing' | 'release', string> = {
  listing:
    'You are editing a draft. Nothing is sent to Google Play until you press “Submit to review”.',
  release:
    'Track actions are committed to Google Play immediately and affect real users on this track.',
};

export function ReviewNotice({ variant }: { variant: 'listing' | 'release' }) {
  return (
    <div className="flex items-start gap-2 bg-surface-muted border border-border rounded-md px-3 py-2">
      <svg className="w-4 h-4 mt-0.5 text-content-muted shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p className="text-xs text-content-muted">{TEXTS[variant]}</p>
    </div>
  );
}
